import { render } from "./DeleteMixConfirmationModal.vue?vue&type=template&id=16fce20e&ts=true"
import script from "./DeleteMixConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteMixConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__